"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _BrixelIcon = _interopRequireDefault(require("./BrixelIcon"));
var _translation = _interopRequireDefault(require("../Translation/translation"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BrixelSingleTag = props => {
  const {
    className,
    color,
    icon,
    label,
    lang,
    message,
    status,
    text
  } = props;
  const [tag, setTag] = (0, _react.useState)({});
  const getColor = () => {
    if (color) {
      const string = color.toLowerCase();
      return string.charAt(0).toUpperCase() + string.slice(1);
    } else if (status === 'accepted' || status === 'completed' || status === 'updated') {
      return 'Green';
    } else if (status === 'pending') {
      return 'Yellow';
    } else if (status === 'archived') {
      return 'Text';
    } else if (status === 'premium' || status === 'rejected' || status === 'cancelled') {
      return 'Red';
    } else {
      return 'Blue';
    }
  };
  const getIcon = () => {
    if (icon) {
      return icon;
    } else if (status === 'accepted' || status === 'completed' || status === 'visited') {
      return 'check';
    } else if (status === 'pending') {
      return 'clock';
    } else if (status === 'new') {
      return 'star-new';
    } else if (status === 'archived') {
      return 'archive';
    } else if (status === 'updated') {
      return 'update-property';
    } else if (status === 'rejected' || status === 'cancelled') {
      return 'close-small';
    } else {
      return '';
    }
  };
  const getTypeText = textTag => {
    switch (textTag) {
      case 'new':
        {
          return 'New';
        }
      case 'updated':
        {
          return 'Updated';
        }
      case 'archived':
        {
          return 'Archived';
        }
      case 'premium':
        {
          return 'Premium';
        }
      case 'pre-market':
        {
          return 'Pre-market';
        }
      default:
        return textTag;
    }
  };
  (0, _react.useEffect)(() => {
    setTag({
      ...tag,
      text: text
    });
  }, [text]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `bg${getColor()}100 txt${getColor()}400 brdRadiusSmall px-1 pt-small-4 pb-small-2 fsize-200 fweight-500 dis-f a-c w-fit ${className}`
  }, getIcon() && (/*#__PURE__*/_react.default.createElement(_BrixelIcon.default, {
    className: "width-px-13 mr-small-4",
    color: getColor(),
    saturationTxt: 400,
    icon: getIcon()
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: 'dis-f'
  }, message && status && (/*#__PURE__*/_react.default.createElement("span", {
    className: label ? 'mr-small-4' : ''
  }, (0, _translation.default)(getTypeText(message[status]), lang))), /*#__PURE__*/_react.default.createElement("span", null, label)));
};
var _default = exports.default = BrixelSingleTag;